const container = document.querySelector('.js-cookies-notice'),
    close = document.querySelector('.js-cookies-notice-close');

if (container) {
    // Do we have a cookie set to prevent this notice showing?
    if (!document.cookie.split(';').filter(function(item) {
        return item.indexOf('cookiesnotice=') >= 0;
    }).length) {
        // Cookie doesn't exist
        // Show the notice
        container.classList.add('show');

        // Clicking on the close link hides the cookies notice and sets a cookie to cause it not to show in the future
        close.addEventListener('click', function (e) {
            e.preventDefault();

            var d = new Date();

            // Hide notice
            container.classList.remove('show');

            d.setTime(d.getTime() + (182.5 * 24 * 60 * 60 * 1000)); // ~ 6 months from now

            // Set the cookie
            document.cookie = "cookiesnotice=1; expires=" + d.toUTCString() + "; path=/";
        });
    }
}